import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const ArticlesAndResearch = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === "ar" ? "ar_AR" : "en_US";

  const articles = t("articlesPage.articles", { returnObjects: true });
  const faq = t("articlesPage.faq", { returnObjects: true });

  return (
    <div className="container my-5 pt-5">
      <Helmet>
        <link rel="canonical" href="https://saleemsmile.com/articles" />
        <title>{t("articlesPage.meta.title")}</title>
        <meta name="description" content={t("articlesPage.meta.description")} />
        <meta name="keywords" content={t("articlesPage.meta.keywords")} />
        <meta property="og:title" content={t("articlesPage.meta.ogTitle")} />
        <meta
          property="og:description"
          content={t("articlesPage.meta.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://via.placeholder.com/800x450.png?text=Dental+Articles"
        />
        <meta property="og:type" content="article" />
        <meta property="og:locale" content={locale} />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faq.map((item) => ({
              "@type": "Question",
              name: item.q,
              acceptedAnswer: {
                "@type": "Answer",
                text: item.a,
              },
            })),
          })}
        </script>
      </Helmet>

      <div className="d-flex flex-column align-items-center">
        <h2 className="mb-2 fs-1 fw-bolder">{t("articlesPage.heading")}</h2>
        <svg
          viewBox="0 0 200 100"
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "140px", marginTop: "-30px" }}
        >
          <defs>
            <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#2BA3DF" />
              <stop offset="100%" stopColor="#6dd5ed" />
            </linearGradient>
          </defs>
          <path
            d="M10,40 Q50,90 190,30"
            stroke="url(#lineGradient)"
            strokeWidth="8"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <div className="row g-4">
        {articles.map((article, idx) => (
          <div key={idx} className="col-md-4">
            <div
              className="card h-100 border-0 shadow-lg rounded-4 overflow-hidden"
              style={{
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
              }}
            >
              <div className="overflow-hidden"></div>
              <div className="card-body text-center">
                <h5 className="card-title fw-bold mb-3">{article.title}</h5>
                <p className="card-text text-muted mb-4">
                  {article.description}
                </p>
                <Link
                  to={article.link}
                  className="btn px-4 text-white fw-semibold"
                  style={{
                    background: "linear-gradient(to right, #2BA3DF, #6dd5ed)",
                    border: "none",
                    borderRadius: "30px",
                  }}
                >
                  {t("articlesPage.readMore")}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArticlesAndResearch;
